import { whitelabelConfig } from '@/lib/constants/whitelabelConfig'
import {
  Button,
  ButtonProps,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  chakra,
  forwardRef,
} from '@eigtech/ui-shared-dave'
import { FaAppStore, FaGooglePlay, FaMobileAlt } from 'react-icons/fa'

export type ApplicationMenuProps = { isCollapsed: boolean } & ButtonProps

export const ApplicationMenu = forwardRef<ApplicationMenuProps, 'button'>(
  ({ isCollapsed, ...props }, ref) => {
    return (
      <Menu>
        <MenuButton ref={ref} as={Button} id="navigation_appMenu" {...props}>
          <chakra.span alignItems="center" display="flex" maxW="full">
            <FaMobileAlt />
            <chakra.span
              data-test-id="navigation_userName"
              flex={1}
              marginLeft={3}
              overflow="hidden"
              textAlign="left"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {!isCollapsed && 'Mobile Apps'}
            </chakra.span>
          </chakra.span>
        </MenuButton>

        <MenuList color="chakra-body-text" data-test-id="navigation_appMenu_list">
          <MenuItem as="a" href={whitelabelConfig.iosAppLink} icon={<FaAppStore />} target="_blank">
            iOS App Store
          </MenuItem>
          <MenuItem
            as="a"
            href={whitelabelConfig.androidAppLink}
            icon={<FaGooglePlay />}
            target="_blank"
          >
            Google Play Store
          </MenuItem>
        </MenuList>
      </Menu>
    )
  }
)
